import {api} from 'services/api';
import {ResponseData} from 'types/response-data';
import queryParams from 'utils/query-params';

const getmappingCatalogExports = api.injectEndpoints({
  endpoints: builder => ({
    getmappingCatalogExports: builder.query<Response, Request>({
      query: params => {
        return {
          method: 'GET',
          url: `export/pdf/product-catalog-pricing`,
          params: queryParams(params, '|'),
        };
      },
    }),
  }),
});

type Request = {};

type Response = ResponseData<{}>;

export const {useLazyGetmappingCatalogExportsQuery} = getmappingCatalogExports;
